<script>
/**
 * 站内链接统一出口（新首页专用）
 * 根据 nh-links 的映射规则渲染 router-link / 真实 <a> / 占位 <a>。
 * 外部通过 class/attrs 传入样式（Vue 2 会自动合并 class 到根节点）。
 */
import { resolveNewHomeLink } from '../nh-links'

export default {
  name: 'NhLink',
  props: {
    to: { type: [String, Object], default: '' },
    href: { type: String, default: '' },
    external: { type: Boolean, default: false }
  },
  computed: {
    resolved() {
      if (this.href) return { kind: 'href' }
      if (typeof this.to === 'string' && this.to) return resolveNewHomeLink(this.to)
      if (this.to && typeof this.to === 'object') return { kind: 'route', to: this.to }
      return { kind: 'none' }
    }
  }
}
</script>

<template>
  <router-link v-if="resolved.kind === 'route'" :to="resolved.to">
    <slot />
  </router-link>
  <a
    v-else-if="resolved.kind === 'href'"
    :href="href"
    :target="external ? '_blank' : undefined"
    :rel="external ? 'noopener' : undefined"
  >
    <slot />
  </a>
  <!-- 尚未移植的站内页面：占位链接（不可跳转） -->
  <a v-else href="javascript:;">
    <slot />
  </a>
</template>
